import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: Convex generated API lives outside src/
import type { ICompanyContext, TCompanyMemberRole } from '@/@types/company';

export function useCompanyContext(): ICompanyContext {
  const currentMembership = useQuery(api.companies.members.getCurrentMembership);
  const currentCompany = useQuery(api.companies.queries.getByUser);

  return useMemo(() => {
    const isLoading = currentMembership === undefined || currentCompany === undefined;
    if (isLoading) {
      return {
        currentCompany: null,
        companyRoles: [] as TCompanyMemberRole[],
        isCompanyUser: false,
        isLoading: true,
      };
    }
    if (currentMembership && currentCompany) {
      return {
        currentCompany: {
          _id: currentCompany._id,
          orgId: currentCompany.orgId,
          name: currentCompany.name,
          email: currentCompany.email,
          phoneNumber: currentCompany.phoneNumber,
          address: currentCompany.address,
          website: currentCompany.website,
          country: currentCompany.country,
          status: currentCompany.status,
          allowedInsuranceTypeIds: currentCompany.allowedInsuranceTypeIds,
          createdAt: currentCompany.createdAt,
          updatedAt: currentCompany.updatedAt,
        },
        companyRoles: currentMembership.roles as TCompanyMemberRole[],
        isCompanyUser: true,
        isLoading: false,
      };
    }
    return {
      currentCompany: null,
      companyRoles: [] as TCompanyMemberRole[],
      isCompanyUser: false,
      isLoading: false,
    };
  }, [currentMembership, currentCompany]);
}
